(() => {
  angular
    .module('specsguardApp')
    .directive('sgTableFilter', sgTableFilter);

  sgTableFilter.$inject = [];

  function sgTableFilter () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-header/sg-table-filter.html',
      controller: 'sgTableFilterCtrl',
      controllerAs: '$sgTableFilterCtrl',
    };
  }
})();
